export default {
  namespaced: true,
  state: {
    accountInfo: {}
  },
  mutations: {
    SET_ACCOUNTINFO (state, v) {
      state.accountInfo = v
    }
  },
  actions: {}
}
